import type { FC } from 'react';
import React from 'react';
import type { AccountBenchCandidate, Opportunity } from '@axiom/validation';
import {
  AccordionsItem,
  AccordionsItemHeader,
  AccordionsItemSection,
  Badge,
  Card,
  CardHeader,
  CardSection,
  Layout,
  Paragraph,
  SmallHeader,
} from '@axiom/ui';

import EmptyPosition from '../../public/svg/empty-position.svg';

import { OpportunityTalentClientBenchList } from './OpportunityTalentClientBenchList';
import { OTScrollable } from './OpportunityTalentParentPositionStyles';

export type OpportunityTalentClientBenchProps = {
  opportunity: Opportunity;
  benchCandidates: AccountBenchCandidate[];
};

export const OpportunityTalentClientBench: FC<
  OpportunityTalentClientBenchProps
> = ({ opportunity, benchCandidates }) => {
  return (
    <AccordionsItem name="client-bench" expanded>
      <Card>
        <CardHeader>
          <AccordionsItemHeader>
            <Layout
              direction="horizontal"
              horizontalGutter="8px"
              position="middle"
            >
              <Badge name="client-bench-count" background="gray">
                {benchCandidates.length}
              </Badge>
              <SmallHeader maxLines={1}>Client Bench</SmallHeader>
            </Layout>
          </AccordionsItemHeader>
        </CardHeader>
        <OTScrollable>
          <AccordionsItemSection>
            <CardSection>
              {benchCandidates.length > 0 ? (
                <OpportunityTalentClientBenchList
                  opportunity={opportunity}
                  benchCandidates={benchCandidates}
                />
              ) : (
                <Layout direction="horizontal" horizontalGutter="16px">
                  <EmptyPosition width={117} height={117} />
                  <Layout direction="vertical" verticalGutter="16px">
                    <SmallHeader>No one to show</SmallHeader>
                    <Paragraph>
                      No candidates with prior relationships to this account.
                    </Paragraph>
                  </Layout>
                </Layout>
              )}
            </CardSection>
          </AccordionsItemSection>
        </OTScrollable>
      </Card>
    </AccordionsItem>
  );
};
